var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAccessToLinks)?_c('c-links-chips',_vm._g({attrs:{"links":_vm.alarm.links,"small":_vm.small,"inline-count":_vm.inlineCount,"category":_vm.category,"only-icon":_vm.onlyIcon}},_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }